import React from 'react';
import PropTypes from 'prop-types';
import Image from 'components/Image';
import Link from 'components/Link';
import s from './TopicMovieReviewCard.scss';

function TopicMovieReviewCard(props) {
  const { data } = props;
  const {
    title,
    releaseDate,
    cast,
    movieGenre,
    originalLanguage,
    movieDuration,
    movieCriticRating,
    movieAudienceCertificate,
    url,
    imageId,
  } = data;
  const criticRating = `Critic's Rating`;
  const getTime = minutes => {
    const hours = Math.floor(minutes / 60);
    const remainingMinutes = minutes % 60;

    return `${hours} hrs ${remainingMinutes} min`;
  };

  const getMovieLanguage = language => {
    if (!language || !Array.isArray(language) || !language.length) {
      return '';
    }
    return language.join();
  };

  const getMovieGenres = genres => {
    if (!genres || !Array.isArray(genres) || !genres.length) {
      return '';
    }
    return genres[0].split(',').join(',');
  };

  const generateCastUrl = () => cast?.split(' ')?.join('-');

  return (
    <div>
      <Link to={url} className={s.moviereview_card}>
        <div className={s.figure_wrap}>
          <figure className={s.image}>
            <div className={s.content}>
              <Image
                src={`https://static.toiimg.com/thumb/imgsize-23456,msid-${imageId},width-168,resizemode-4/${imageId}.jpg`}
                alt={title}
              />
            </div>
          </figure>
          <div className={s.details}>
            {title && (
              <div className={s.movie_name}>
                <span>{title}</span>
              </div>
            )}
            {Array.isArray(cast) &&
              !!cast.length && (
                <div className={s.castnames_wrapper}>
                  {cast.map((casts, i) => (
                    <a key={i} href={() => generateCastUrl(casts)}>
                      {casts}
                    </a>
                  ))}
                </div>
              )}
            {originalLanguage || movieGenre || movieAudienceCertificate ? (
              <div className={s.language_catgry}>
                {getMovieLanguage(originalLanguage)}{' '}
                {originalLanguage && movieGenre && <span>|</span>}{' '}
                {getMovieGenres(movieGenre)}{' '}
                {movieAudienceCertificate && movieGenre && <span>|</span>}{' '}
                {movieAudienceCertificate}
              </div>
            ) : null}
            {movieCriticRating && (
              <div className={s.critic_rating}>
                <div className={s.head}>${criticRating}</div>
                <div className={s.starrating}>{movieCriticRating}</div>
              </div>
            )}
            <div className={s.releaseDate}>
              {releaseDate?.date}{' '}
              {releaseDate?.date && movieDuration && <span>|</span>}{' '}
              {movieDuration && getTime(movieDuration)}
            </div>
          </div>
        </div>
      </Link>
    </div>
  );
}

TopicMovieReviewCard.propTypes = {
  data: PropTypes.objectOf({}),
};
TopicMovieReviewCard.defaultProps = {
  data: [],
};

export default TopicMovieReviewCard;
